import { useEffect } from "react";
import Lenis from "lenis";

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({
      autoRaf: true,
      smoothWheel: true,
      lerp: 0.075,
      anchors: false,
    });

    return () => lenis.destroy();
  }, []);

  return null;
};